/* tslint:disable */
import { Energy } from './energy';

/**
 */
export class ViewselectionCriteriaFilter {
    energies?: Energy;
    manufacturer?: Energy;
    series?: Energy;
    origines?: Energy;
    processes?: Energy;
    model?: Energy;
    size?: Energy;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/viewselection-criteria-filter.ts